const API_BASE_URL = (process.env.REACT_APP_ANINA_AUTH_API_URL || "http://localhost:8000").replace(/\/$/, "");
const CSRF_INTENT = "anina-auth-v1";

async function readJson(response) {
  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const detail = payload?.detail || "Watchlist request failed.";
    throw new Error(typeof detail === "string" ? detail : detail?.message || "Watchlist request failed.");
  }
  return payload;
}

export async function getUserWatchlist() {
  const response = await fetch(`${API_BASE_URL}/watchlist`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  return readJson(response);
}

export async function addUserWatchlistSymbol(symbol) {
  const response = await fetch(`${API_BASE_URL}/watchlist/symbols`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Intent": CSRF_INTENT,
    },
    body: JSON.stringify({ symbol }),
  });
  return readJson(response);
}

export async function removeUserWatchlistSymbol(symbol) {
  const normalizedSymbol = String(symbol || "").trim().toUpperCase();
  const response = await fetch(
    `${API_BASE_URL}/watchlist/symbols/${encodeURIComponent(normalizedSymbol)}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "X-CSRF-Intent": CSRF_INTENT,
      },
    },
  );
  return readJson(response);
}
